import {IndustryMapping, IndustryType} from "../../resources/application"
import React from "react"
import {Editable, EditableDropDownField} from "../HorizontalField/EditableHorizontalField"

export interface EditableIndustryProps {
	industry?: IndustryType
	setIndustry: (value: IndustryType) => void
	isEditing: boolean
	isDisabled: boolean
	isAllowed: boolean
	onStartEdit: () => void
	onCancel: () => void
	update: (value: IndustryType) => void
	className?: string
}

export function EditableIndustryField(props: EditableIndustryProps) {
	if (props.industry) {
		return (
			<Editable
				label="Industry"
				isEditing={props.isEditing}
				isDisabled={props.isDisabled}
				isAllowed={props.isAllowed}
				onStartEdit={props.onStartEdit}
				onCancel={props.onCancel}
				setValue={props.setIndustry}
				value={props.industry}
				initial={props.industry}
				update={props.update}
				className={props.className}
				possibleValues={IndustryMapping}
			>
				{EditableDropDownField}
			</Editable>
		)
	}

	return null
}
